import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { initFbPixel } from './lib/fbPixel';
export function App() {
  useEffect(() => {
    initFbPixel();
  }, []);
  return <LandingPage data-id="element-0" />;
}